"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
ProductsListDirective.$inject = ['storage', '_product', '_shop', '$location', '$timeout'];
function ProductsListDirective(storage, _product, _shop, $location, $timeout) {
    return {
        scope: {
            category: '=',
            products: '=',
            activeFilters: '=',
            title: '=',
            mobileTitle: '=',
            breadcrumbs: '=',
            remove: '=',
            removeSingle: '=',
            showFilters: '=',
            sortItems: '='
        },
        template: require('./views/products-list.html'),
        link: function (scope, element, attrs, ngModel) {
            scope.initWatch = true;
            var preview = storage.getItem('shop_preview');
            if (preview != null) {
                scope.product_list_type = preview;
            }
            else {
                scope.product_list_type = 'table';
            }
            scope.title = scope.category ? scope.category.name : scope.title;
            scope.setType = function (type) {
                scope.product_list_type = type;
                storage.setItem('shop_preview', type);
                document.querySelector(".products-list").scrollTop = 0;
            };
            scope.sortArray = _shop.getSortTypes();
            scope.sortProducts = function (sort) {
                _.each(scope.sortArray, function (child, index) {
                    child.active = 0;
                });
                sort.active = 1;
                scope.products = _.orderBy(scope.products, [
                    function (product) { return product._stock != '0' ? 0 : 1; },
                    sort.sort
                ], ['asc', sort.type]);
            };
            scope.sort_open = false;
            scope.toggleSort = function () {
                scope.sort_open = !scope.sort_open;
            };
            scope.$watch('sortItems', function (value) {
                if (value && value.name) {
                    scope.sortProducts(value);
                }
            });
            $(document).bind('click', function (event) {
                if (!angular.element(document.querySelector('.sort-dropdown')).find(event.target)[0]
                    && !angular.element(document.querySelector('#myDropdown')).find(event.target)[0]) {
                    scope.$apply(function () {
                        scope.sort_open = false;
                    });
                }
            });
            scope.removeAllFilters = function () {
                scope.remove = true;
                console.log(scope.remove);
            };
            scope.removeFilter = function (value, filter) {
                scope.removeSingle = { value: value, filter: filter };
            };
            //product-box modal, listanje
            scope.$watch('products', function (value) {
                _product.setList(scope.products);
                // Initial sort only
                if (value && value.length > 0 && scope.initWatch) {
                    scope.initWatch = false;
                    var activeSort = _.find(scope.sortArray, ['active', 1]);
                    if (activeSort) {
                        scope.sortProducts(activeSort);
                    }
                }
            });
            // Re-sort when filtering event is received
            scope.$on('productsFiltered', function () {
                $timeout(function () {
                    var activeSort = _.find(scope.sortArray, ['active', 1]);
                    if (activeSort && scope.products && scope.products.length > 0) {
                        scope.sortProducts(activeSort);
                    }
                }, 0);
            });
            scope.openModal = function (product, index) {
                $location.search('productView', product._id);
                var cat_name = scope.category ? scope.category.name : null;
                _product.viewProduct(product, index, cat_name);
            };
            var init = true;
            var initWatch = scope.$watch(function () {
                return $location.search().productView;
            }, function (nval, oval) {
                if (init && nval != undefined && oval != undefined && nval == oval) {
                    var product = _.find(scope.products, { _id: parseInt(nval) });
                    var index = _.indexOf(scope.products, product);
                    var cat_name = scope.category ? scope.category.name : null;
                    _product.viewProduct(product, index, cat_name);
                    initWatch();
                }
                init = false;
            });
            scope.exportList = function () {
                var sort = _.find(scope.sortArray, ['active', 1]);
                _shop.exportListModal(scope.products, sort).then(function (response) {
                    console.log(response);
                }, function (error) {
                    console.log('error');
                });
            };
            scope.openFilters = function () {
                scope.showFilters = true;
                if (document.querySelector('.shop-filters')) {
                    document.querySelector('.shop-filters').scrollTop = 0;
                }
            };
        }
    };
}
exports.ProductsListDirective = ProductsListDirective;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/shop/directives/ProductsListDirective.js
// module id = 365
// module chunks = 0